<p>additional-purchase-info works!</p>
